// import React, { Fragment, useEffect, useState, useContext } from 'react';
import React, { useEffect, useState, useContext } from 'react';
// import './check-feasibility.scss';
import DedicatedAccordionComponent from 'home/view/check-feasibility/component/dedicatedaccordion';
// import RequestType from 'home/view/manage-feasibility/components/molecules/RequestType';
import LandingPageAOI from 'home/view/manage-feasibility/pages/LandingPageAOI';
// import UnauthPage from 'home/view/manage-feasibility/pages/UnauthPage';

import {
  scrollToTop,
  gtag_report_conversion,
  getFromSessionStorage,
  facebookSmbLead,
  // navigateTo,
  findParamFromUrl,
  isSingleUpgradeOrShiftingJourney
  // setInSessionStorage
} from 'common/utils/app.utils';

import { MODULE_ID, FEASIBILITY_RESPONSE, FEASIBILITY_STATUS, DEDICATED_FEASIBILITY_RESPONSE, AUTHORIZED_SIGNATORY } from 'home/common/constants/constants';
// import { PRODUCT_TYPE, ROUTES, STORAGE_KEY } from 'common/constants/app.constants';
import { JOURNEY_TYPE, ROUTES, STORAGE_KEY } from 'common/constants/app.constants';
import { trackMOEEvent } from 'common/services/moengage.service';

// import { MOENGAGE_ANALYTICS_EVENT, isBulkUpgrade } from 'common/constants/app.constants';
// import { MULTIPLE_SITE, RADIO_OPTIONS, SINGLE_SITE } from 'home/view/manage-feasibility/constants';

import { MOENGAGE_ANALYTICS_EVENT } from 'common/constants/app.constants';
import { MULTIPLE_SITE } from 'home/view/manage-feasibility/constants';

import { AppContext } from 'App';

// import InfoPanel from './component/info-panel';
import StepsHeader from 'home/components/functional/steps-header/steps.component';
import OrderDetailsAccordion from 'home/view/manage-feasibility/pages/LandingPage/OrderDetailsAccordion';
import { getCurrentLead } from 'tokenGeneration/lead.util';

const CheckFeasibility = (props) => {
  const partyId = findParamFromUrl('partyId', false);
  const productType = findParamFromUrl('productType', false);

  // const { selectedRadio, setSelectedRadio, showSteps, setToast } = useContext(AppContext);
  const { selectedRadio, showSteps, setToast } = useContext(AppContext);
  const [feasibilityData, setFeasibilityData] = useState(feasibilityData);
  // const [disabledRequestType, setDisabledRequestType] = useState(false);

  // let stateToken = props && props.location && props.location.search && new URLSearchParams(props.location.search).get('state');
  // let code = props && props.location && props.location.search && new URLSearchParams(props.location.search).get('code');
  // const hasDedicatedInternet = PRODUCT_TYPE.VPN !== productType;
  // let showInfoPanel = false;

  // if (props.isUnAuthJourney && hasDedicatedInternet) {
  //   showInfoPanel = true;
  // }

  const checkFeasibilityUpdate = (response) => {
    setFeasibilityData(response);
  };

  useEffect(() => {
    showSteps(true);
    trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.CHECK_FEASIBILITY_PAGE_VISIT);
  }, []);

  // useEffect(() => {
  //   if (props?.isUnAuthJourney) {
  //     scrollToTop();
  //     trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.UNAUTH_CHECK_FEASIBILITY_PAGE_VISIT);
  //   } else {
  //     trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.CHECK_FEASIBILITY_PAGE_VISIT);
  //   }
  // }, [props?.isUnAuthJourney]);

  const redirectToPage = () => {
    let feasibilityResponse = props.isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
    const authorizedSignatory = getFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
    let userType = authorizedSignatory && authorizedSignatory.customerSegment;
    facebookSmbLead('Lead');
    gtag_report_conversion();
    let redirectUrl = '';
    if (feasibilityResponse && feasibilityResponse.feasibilityStatus === FEASIBILITY_STATUS.NOT_FEASIBLE_HIGH_CONFIDENCE.key) {
      redirectUrl = ROUTES.DEDICATED_THANK_YOU;
      if (partyId) {
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }
      props.history && props.isdedicatedJourney
        ? props.history.push(redirectUrl, {
            userType: userType,
            noNetwork: userType === 'ENTERPRISE' ? false : true
          })
        : props.history.push(redirectUrl);
    } else {
      redirectUrl = ROUTES.DEDICATED_CHOOSE_PLAN;
      if (partyId) {
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }
      props.history && props.isdedicatedJourney ? props.history.push(redirectUrl) : props.history.push(redirectUrl);
    }
  };

  // const setRequestType = (flag = false) => {
  //   const isMultiSiteJourneySet = getFromSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE);
  //   if (flag) {
  //     // sets the flag
  //     setInSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE, flag);
  //   }
  //   setDisabledRequestType(flag || isMultiSiteJourneySet);
  // };

  // const getCardClass = () => {
  //   if (selectedRadio && selectedRadio.id === SINGLE_SITE && showInfoPanel) {
  //     return 'card network-availability-card';
  //   } else if (selectedRadio && selectedRadio.id === SINGLE_SITE) {
  //     return 'card';
  //   }
  //   return '';
  // };

  const renderDedicatedAccordion = () => {
    return (
      <DedicatedAccordionComponent
        checkFeasibilityUpdate={checkFeasibilityUpdate}
        // stateToken={stateToken}
        // code={code}
        redirectToPage={redirectToPage}
        isdedicatedJourney={props.isdedicatedJourney}
        isUnAuthJourney={props.isUnAuthJourney}
        productType={productType || 'DEDICATED_INTERNET'}
        selectedRadio={selectedRadio}
        setToast={setToast}
        // setRequestType={setRequestType}
        {...props}
      />
    );
  };

  // const renderUnAuthStepper = () => {
  //   if (props.isUnAuthJourney) {
  //     return <StepsHeader activeStepIndex={1} isdedicatedJourney={props.isdedicatedJourney} isUnAuthJourney={true} />;
  //   }

  //   return null;
  // };

  /** RENDER COMMON ACQ PAGE - AUTH FLOW */

  // if (!props?.isUnAuthJourney) {
  //   let isMultiSite = selectedRadio?.id === MULTIPLE_SITE;

  //   if (isMultiSite) {
  //     return <LandingPage {...props} />;
  //   }

  //   return (
  //     <div className="feasibility-requests home single-site-container">
  //       <StepsHeader
  //         hideBackBtn={true}
  //         activeStepIndex={2}
  //         isdedicatedJourney={props.isdedicatedJourney}
  //         isUnAuthJourney={false}
  //         skipNetworkstatus={true}
  //         isMultiSite={true}
  //         showTrackBtn={true}
  //       />
  //       <OrderDetailsAccordion />
  //       {renderDedicatedAccordion()}
  //     </div>
  //   );
  // }

  const renderAuthView = () => {
    const savedLead = getCurrentLead();
    let isMultiSite = selectedRadio?.id === MULTIPLE_SITE;
    const userSelectedSingleUpgrade = getFromSessionStorage(MODULE_ID, STORAGE_KEY.JOURNEY_TYPE) === JOURNEY_TYPE.SINGLE_UPGRADE_SHIFTING;

    if (!!!savedLead || isMultiSite || isSingleUpgradeOrShiftingJourney() || userSelectedSingleUpgrade) {
      return <LandingPageAOI {...props} />;
    }

    return (
      <div className="feasibility-requests home single-site-container">
        <StepsHeader
          hideBackBtn={true}
          activeStepIndex={2}
          isdedicatedJourney={props.isdedicatedJourney}
          isUnAuthJourney={false}
          skipNetworkstatus={true}
          isMultiSite={true}
          showTrackBtn={true}
        />
        <OrderDetailsAccordion />
        {renderDedicatedAccordion()}
      </div>
    );
  };

  return renderAuthView();

  // return <UnauthPage />;
  // return (
  //   <React.Fragment>
  //     <div className="feasibility-requests home single-site-container">
  //       <div className={`${selectedRadio && selectedRadio.id === MULTIPLE_SITE ? '' : 'container-unauth'}`}>
  //         <div className={selectedRadio && selectedRadio.id === SINGLE_SITE ? 'feasibility-requests-container' : ''}>
  //           <div className={getCardClass()}>
  //             {selectedRadio && selectedRadio.id === SINGLE_SITE && showInfoPanel && <InfoPanel isUnAuth={props.isUnAuthJourney} />}
  //             <div className="check_feasibibility_form">
  //               {renderUnAuthStepper()}
  //               {props.isdedicatedJourney ? renderDedicatedAccordion() : null}
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </React.Fragment>
  // );
};

export default CheckFeasibility;
